import type {
	EventMilestoneProgressValue,
	EventMilestonesState,
} from "@/types";

function mergeBranchValue(
	local: EventMilestoneProgressValue | undefined,
	remote: EventMilestoneProgressValue | undefined,
): EventMilestoneProgressValue | undefined {
	if (local === undefined) return remote;
	if (remote === undefined) return local;

	if (typeof local === "boolean" || typeof remote === "boolean") {
		return local === true || remote === true;
	}

	return {
		free:
			local.free === true || remote.free === true
				? true
				: (local.free ?? remote.free),
		premium:
			local.premium === true || remote.premium === true
				? true
				: (local.premium ?? remote.premium),
	};
}

/** Prefer claimed=true edges so optimistic FE claims survive stale overview snapshots. */
export function mergeMilestoneClaims(
	local: EventMilestonesState | null | undefined,
	remote: EventMilestonesState | null | undefined,
): EventMilestonesState | null {
	if (!remote && !local) return null;
	if (!remote) return local ?? null;
	if (!local) return remote;

	const keys = new Set([...Object.keys(local), ...Object.keys(remote)]);
	const out: EventMilestonesState = {};
	for (const k of keys) {
		const id = +k;
		if (!Number.isFinite(id)) continue;
		const merged = mergeBranchValue(local[id], remote[id]);
		if (merged !== undefined) out[id] = merged;
	}
	return out;
}
